const BODY_SNIPPET_MAX = 200;
const JSON_CONTENT_TYPE_PATTERN = /^application\/json\b/i;

export type NetworkError = Error & {
  status: number;
  contentType: string | null;
  bodySnippet: string;
};

export const createNetworkError = (
  status: number,
  contentType: string | null,
  bodySnippet: string,
): NetworkError => {
  const error = new Error(
    `Network error ${status} (content-type: ${contentType ?? 'unknown'})`,
  ) as NetworkError;
  error.name = 'NetworkError';
  error.status = status;
  error.contentType = contentType;
  error.bodySnippet = bodySnippet;
  return error;
};

export const parseJsonResponse = async <T = unknown>(
  response: Response,
): Promise<T> => {
  const contentType = response.headers.get('content-type');
  const isJson =
    contentType !== null && JSON_CONTENT_TYPE_PATTERN.test(contentType);
  if (!isJson) {
    const snippet = await response.text().then(
      body => body.slice(0, BODY_SNIPPET_MAX),
      () => '',
    );
    throw createNetworkError(response.status, contentType, snippet);
  }
  return (await response.json()) as T;
};
